import actions from './user.actions';
import getters from './user.getters';
import mutations from './user.mutations';

export interface User {
  firstName: string;
  lastName: string;
}

export interface TeamData {
  teamId: string;
  teamName: string;
}

export interface State {
  username: string;
  token: string;
  email: string;
  user: User;
  tokenExp: string;
  teamID: string;
  teamName: string;
  prevTeamData: TeamData;
  userType: string;
  accessToken: string;
  oapAccessToken: string;
  isAuthenticated: Boolean;
  dashboard: string;
  loginCount: Number;
  lastLogin: String;
  roleId: string;
  roleName: string;
  isRoleValid: Boolean;
  isBillingAdmin: Boolean;
}

const initialState: State = {
  username: '',
  email: '',
  token: '',
  user: {
    firstName: '',
    lastName: '',
  },
  tokenExp: '',
  teamID: '',
  teamName: '',
  prevTeamData: { teamId: '', teamName: '' },
  userType: '',
  accessToken: '',
  oapAccessToken: '',
  dashboard: '',
  isAuthenticated: false,
  loginCount: 0,
  lastLogin: '',
  roleId: '',
  roleName: '',
  isRoleValid: true,
  isBillingAdmin: false,
};

export default {
  namespaced: true,
  state: initialState,
  actions: actions,
  mutations: mutations,
  getters: getters,
};
